export const Role = {
    Admin: 'Admin',
    AdminWeb: 'AdminWeb',
    EnvanterAdmin: 'EnvanterAdmin',
    User: 'User'
}